<template>
  <!-- 友邦登录 -->
  <aia-container>
    <div class="aia-agent-box" slot="login">
      <img
        class="aia-back"
        src="@/assets/images/common/back-white.svg"
        alt=""
        @click="handleBack"
      />
      <div class="aia-agent-box-item">
        <el-form
          class="login-form form-custom aia-form-custom"
          ref="form"
          label-position="top"
          label-width="80px"
          @submit.native.prevent
          :hide-required-asterisk="true"
          :rules="rules"
          :model="form"
        >
          <el-form-item
            label=""
            class="form-item-primary"
            prop="aia_subsidiary_organ"
          >
            <el-select
              class="subsidiary-organ input-custom-wrap"
              v-model="form.aia_subsidiary_organ"
              placeholder="请选择所属机构"
              v-track="{ type: 'click', name: `agentlogin.company_select` }"
            >
              <el-option
                v-for="item in organList"
                :value="item"
                :label="item"
                :key="(item || '').toString()"
              >
                {{ item }}
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label=""
            class="form-item-primary"
            prop="aia_agent_code"
          >
            <!-- 代理人编码 -->
            <BaseInput
              v-model="form.aia_agent_code"
              :autofocus="false"
              placeholer="请输入代理人编码"
              @blur="handleCodeBlur"
            />
          </el-form-item>
        </el-form>

        <el-button
          class="button-custom aia-button-custom aia-agent-button"
          @click="handleSubmit"
        >
          确 认 登 录
        </el-button>
        <div class="aia-agent-tips">
          <i class="el-icon-warning-outline aia-agent-tips_icon"></i>
          <span class="aia-agent-tips_text">
            请务必填写正确的代理人编码, 生成您的专属海报
          </span>
        </div>
      </div>
    </div>
  </aia-container>
</template>

<script>
import AiaContainer from './components/AiaContainer'
import BaseInput from '@/components/common/BaseInput.vue'
import { handleLogin } from '@/utils/mutiple.js'
import _throttle from 'lodash/throttle'
import { setItem } from '@/utils/storage-main.js'
import { getBusinessType } from '@/constant'
import loginSDK from '@/utils/base'

const AiaConfig = getBusinessType()
const AIA_ID = AiaConfig.id

export default {
  data() {
    return {
      organList: [],
      form: { aia_subsidiary_organ: '', aia_agent_code: '' },
    }
  },
  components: { AiaContainer, BaseInput },
  computed: {
    rules() {
      return {
        aia_subsidiary_organ: [
          {
            required: true,
            message: '请选择所属机构',
            trigger: 'blur',
          },
          {
            validator: async (rule, value, callback) => {
              if (!value) return callback(new Error('请选择所属机构'))

              return callback()
            },
          },
        ],
        aia_agent_code: [
          {
            required: true,
            message: '请输入代理人编码',
            trigger: 'blur',
          },
          {
            validator: async (rule, value, callback) => {
              if (!value) return callback(new Error('请输入代理人编码'))

              return callback()
            },
          },
        ],
      }
    },
  },
  created() {
    this._initEnter()
  },
  methods: {
    _initEnter() {
      if (loginSDK.getCurrentToken()) {
        this.getOrganList()
        return
      }

      this.handleBack()
    },
    async getOrganList() {
      const res = await this.$store.dispatch('getAiaOrganList')

      this.organList = (res && res?.data?.subsidiary_organ) || []
    },
    handleSubmit: _throttle(
      function () {
        this.$refs['form'].validate((valid) => {
          if (!valid) return

          this.$gotinTrack.standaloneSendData({ name: `agentlogin.confirm` })
          this.toSubmit()
        })
      },
      500,
      { trailing: false }
    ),
    async toSubmit() {
      const res = await this.$store.dispatch('setSaveExtraInfo', {
        source: AIA_ID,
        prop: {
          ...this.form,
        },
      })

      if (res?.data.state == 'success') {
        setItem('aiaLogined', true)
        handleLogin(AIA_ID)

        return
      }

      this.$message.error('请填入有效的代理码')
    },
    handleBack() {
      this.$router.replace({
        path: '/aia',
        query: { ...this.$route.query },
      })
    },
    handleCodeBlur() {
      this.$gotinTrack.standaloneSendData({
        name: `agentlogin.agentcode_enter`,
      })
    },
  },
}
</script>

<style lang="scss">
.aia-agent-box {
  width: 100%;
  margin-top: 100px;
  .aia-agent-box-item {
    margin: 0 60px;
  }
  .aia-agent-tips {
    margin: 18px auto 0 auto;
    width: 275px;
    font-size: 10px;
  }
  .aia-agent-tips_text {
    color: rgba(68, 88, 123, 0.8);
  }
  .aia-agent-tips_icon {
    color: rgba(246, 59, 109, 1);
  }
  @media screen and (min-height: 800px) {
    .aia-agent-box-item {
      margin-top: 90px;
    }
  }
  @media screen and (min-width: 415px) and (max-width: 1500px) {
    .aia-agent-box-item {
      margin-left: 15vw;
      margin-right: 15vw;
    }
    .aia-agent-tips_text {
      color: #ffffff;
    }
  }
  .form-custom .el-form-item__label {
    padding: -10px 20px 0;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: rgba(255, 255, 255, 0.8);
  }

  .el-form-item {
    margin-bottom: 16px;
  }

  .aia-agent-button {
    margin-top: 20px;
  }
  .subsidiary-organ {
    width: 100%;
  }
  .el-input--suffix .el-input__inner {
    height: 50px;
    line-height: 48px;
    border-color: rgba(0, 0, 0, 0);
    border-radius: 8px;
    padding-left: 24px;
    background: rgba(255, 255, 255, 0.6);
  }
  .el-select .el-input.is-focus .el-input__inner {
    border-color: rgba(0, 0, 0, 0);
  }
  .input-custom.el-input .el-input__inner {
    background-color: rgba(255, 255, 255, 0.6);
    border-color: rgba(0, 0, 0, 0);
    color: #3d4d68;
    height: 50px;
  }
  .el-input__inner::placeholder {
    color: rgba(61, 77, 104, 0.6) !important;
  }
  .el-input__inner::placeholder {
    color: rgba(61, 77, 104, 0.6) !important;
    padding-left: 0px;
  }
  .el-input__inner::-webkit-input-placeholder {
    color: rgba(61, 77, 104, 0.6) !important;
    padding-left: 0px;
  }
  .input-custom-placeholder {
    color: rgba(61, 77, 104, 0.6) !important;
  }
  .aia-back {
    position: absolute;
    left: 25px;
    top: 20px;
  }
  .el-form-item.is-error .input-custom .el-input__inner,
  .el-form-item.is-error .input-custom .el-input__inner:focus,
  .el-form-item.is-error .input-custom .el-textarea__inner,
  .el-form-item.is-error .input-custom .el-textarea__inner:focus {
    background-color: rgba(255, 255, 255, 0.6);
    border-color: rgba(0, 0, 0, 0);
  }
  .form-item-primary .el-input__inner {
    color: #3d4d68;
  }
  .el-select .el-input .el-select__caret {
    color: rgba(61, 77, 104, 0.8);
  }
}
.aia-form-custom {
  .form-item-primary.el-form-item {
    margin-bottom: 16px;
  }
  .form-item-primary.is-error {
    margin-bottom: 30px;
  }
}
</style>
